<template>
  <div
    class="calc-control"
    :class="wrapperClass"
  >
    <b-button
      v-for="(paymentType, index) in paymentTypes"
      :key="index"
      :class="[(amountTendered < minTendered && !refundOrderId) || isPaymentProcessing? 'disabled' : '', paymentType.name.toString().toLowerCase().split(' ').join('')]"
      variant="dark"
      @click="!isPaymentProcessing ? $emit('pay', paymentType) : null"
    >
      {{ paymentType.name }}
    </b-button>
  </div>
</template>

<script>
export default {
  name: "CheckoutPaymentButtons",
  props: {
    paymentTypes: {
      type: Array,
      default: () => [],
    },
    amountTendered: {
      type: Number,
      default: 0,
    },
    refundOrderId: {
      type: [Number, String],
      default: null,
    },
    // Preserves the Phase-1 lock: the parent's pay() re-checks the flag too.
    isPaymentProcessing: {
      type: Boolean,
      default: false,
    },
    // Mobile row gates at 0.01, desktop row gates at 0 (behaviour preserved).
    minTendered: {
      type: Number,
      default: 0.01,
    },
    wrapperClass: {
      type: [String, Array],
      default: "",
    },
  },
};
</script>
